// extracted by mini-css-extract-plugin
export default {"detailImage":"Details_detailImage__VGPui","detailInfoText":"Details_detailInfoText__fJALX","paddingMultiImageUpload":"Details_paddingMultiImageUpload__qLecm"};